const PaymentConnectorStatus = Object.freeze({
  PENDING: 'pending',
  COMPLETED: 'completed',
  DEPRECATED: 'deprecated',
});

module.exports = {
  PaymentConnectorStatus,
};
